import * as React from 'react';
import {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import Sticky from 'react-stickynode';

import {Margin, LinkStyle, SITE, HeadlineLevel} from 'features/ui/enums';
import {SITE_URLS} from 'features/search/constants';
import {getCurrentSite} from 'features/services/utils/env-helper';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {ImageSizes} from 'components/organisms/Shell/image-size-enum';
import {gtmEventsClickToBuyLoad} from 'features/services/googleTagManager/events';
import {ClickToBuyInfoPageViewModel} from 'features/template/viewModels/ClickToBuyInfoPageViewModel';
import {getQueryAsObject} from 'components/organisms/BuyResidenceGeneral/services/helpers';
import {getBuyResidenceCookie} from 'components/organisms/BuyResidenceGeneral/services/api';
import {NotAvailable} from 'components/organisms/BuyResidenceGeneral/components/_notAvailable';

import './style.scss';
import '@organisms/ContentBlocks/ImageHeader/ResidenceActionButton/style.scss';

import {A} from 'components/atoms/LinksAndButtons/A';
import {P} from 'components/atoms/Text/P';
import {Icon} from 'components/atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonState, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';
import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {UserAgent} from 'components/atoms/UserAgent';
import {Container} from 'components/atoms/Layout/Container';
import {AsyncImage} from 'components/atoms/Media/AsyncImage';
import {ContentArea} from 'components/organisms/GeneralComponents/ContentArea';
import {ContactCard} from 'components/molecules/ContactCard';
import {SiteSpecificContent} from 'components/atoms/SiteSpecificContent';
import {
    C2BObjectInfoCard as C2BObjectInfoCardNew
} from 'components/organisms/BuyResidenceGeneral/components/_c2bObjectInfoCard';
import {ImageHeaderMenu} from 'components/organisms/ContentBlocks/ImageHeader/ImageHeaderMenu';
import {BookingButton} from '@organisms/ContentBlocks/ImageHeader/ResidenceActionButton/_bookingButton';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import { useBuyResidenceStore, selectCurrentObject } from 'features/buyResidence/store/useBuyResidenceStore';
import {InspirationBlock} from "components/blocks/PageLinks/InspirationBlock";
import {useNavigate} from 'react-router';
import {PageModel} from "features/template/types";
import {Headline} from '@atoms/Text/Headline';

type Props = PageModel<ClickToBuyInfoPageViewModel>;

export const ClickToBuyInfoPageRenderer: React.FunctionComponent<Props> = ({viewModel}) => {

    const parameters = getQueryAsObject();
    const navigate = useNavigate();

    const isMobile = useDeviceStore(selectIsMobile);
    const currentObject = useBuyResidenceStore(selectCurrentObject);

    const bookingId = parameters !== null && parameters.hasOwnProperty('bookingId') ? parameters['bookingId'] : null;
    const [bookable, setBookable] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {

        if(currentObject === null) {

        } else {
            const objectData = currentObject.stageName + ", " + currentObject.objectNumber;
            gtmEventsClickToBuyLoad(objectData)();
        }

    }, []);

    useEffect(() => {
        if(loading && currentObject)
            checkBookableStatus();
    }, [loading]);

    const scrollToSection = (id: string) => (e: React.SyntheticEvent) => {
        e.preventDefault();

        const element = document.getElementById(id);

        if(element) {
            const yOffset = -120;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    };

    const _onCtaClick = () => {
        const url = getBuyUrl();
        navigate(url);
    };

    const getBuyUrl = () => {
        let url: string;

        const parameters = getQueryAsObject();
        const bookingId = parameters !== null && parameters.hasOwnProperty('bookingId') ? parameters['bookingId'] : null;

        if(typeof viewModel.objectVipKey === 'undefined' || viewModel.objectVipKey === null) {
            url = `${SITE_URLS.clickToBuy}${viewModel.objectId}/`;

            if(bookingId) {
                url += '?bookingId=' + bookingId;
            }

        } else {
            url = `${SITE_URLS.clickToBuy}${viewModel.objectId}/${viewModel.objectVipKey}`;
        }

        return url;
    };

    const checkBookableStatus = async () => {
        //let cookieModel = CookieStore.getClickToBuyModel(currentObject.objectId);
        const jsonModel = await getBuyResidenceCookie(); //CookieStore.getClickToBuyModel(this.props.viewModel.objectId);

        //if(cookieModel && cookieModel.objectId === currentObject.objectId) {

        if(jsonModel && jsonModel.objectId === currentObject?.objectId) {
            setLoading(false);
            setBookable(jsonModel.objectId === currentObject?.objectId);
            return;
        }

        setLoading(false);
        setBookable(false);
    };

    const getHowItWorksId = () => {
        if(viewModel.contentArea && viewModel.contentArea.length > 0 && viewModel.contentArea[0]) {
            return `block-${viewModel.contentArea[0].contentId}`;
        }

        return '';
    };

    const getFaqId = () => {
        if(viewModel.contentArea && viewModel.contentArea.length > 0 && viewModel.contentArea[1]) {
            return `block-${viewModel.contentArea[1].contentId}`;
        }

        return '';
    };
    const [isSticky, setIsSticky] = React.useState(false);

    if(!currentObject) return null;

    const onStickyChange = ({status}) => {
        setIsSticky(status === Sticky.STATUS_FIXED);
    };

    return (
        <div className="click-to-buy-info-page">

            {(!currentObject.isBookable && !bookable) &&
                <NotAvailable />
            }
            {(currentObject.isBookable || (!currentObject.isBookable && bookable)) &&
                <React.Fragment>
                    <div className="click-to-buy-info-page__header">
                        <div className="left-align-header-block">
                            <Container>
                                <div className="left-align-header-block__mobile-background">
                                    <div className="left-align-header-block__text">
                                        {bookingId === null &&
                                            <ReadMore
                                                link={viewModel.objectUrl}
                                                text={getFormattedMessage('jm.components.ClickToBuy.backToObject')}
                                                reversed
                                            />
                                        }
                                        <Headline level={HeadlineLevel.H1}
                                            margin={Margin.L}
                                        >
                                            <FormattedMessage id="jm.components.ClickToBuyInfoPage.headline" />
                                        </Headline>

                                        <SiteSpecificContent sites={[SITE.NO, SITE.SV, SITE.SENIORGARDEN, SITE.BORATT]}>
                                            <P>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.intro" />
                                            </P>
                                        </SiteSpecificContent>

                                        <SiteSpecificContent showOnFinland>
                                            <UserAgent mobile>
                                                <div className="left-align-header-block__icon">
                                                    <Icon name="block-rented-apartment" size={96} />
                                                </div>
                                            </UserAgent>

                                            <P>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.intro" />
                                            </P>
                                            {/*
                                            <ul>
                                                <li><Icon name="input-ok" size={20} /> <FormattedMessage id="jm.components.ClickToBuyInfoPage.uspOne" /></li>
                                                <li><Icon name="input-ok" size={20} /> <FormattedMessage id="jm.components.ClickToBuyInfoPage.uspTwo" /></li>
                                                <li><Icon name="input-ok" size={20} /> <FormattedMessage id="jm.components.ClickToBuyInfoPage.uspThree" /></li>
                                            </ul>
                                            */}
                                        </SiteSpecificContent>
                                    </div>

                                    <UserAgent tablet computer>
                                        <div className="left-align-header-block__icon">
                                            <Icon name="block-rented-apartment" size={isMobile ? 96 : 128} />
                                        </div>
                                    </UserAgent>

                                </div>
                            </Container>
                        </div>
                    </div>

                    <div className="click-to-buy-info-page__content">
                        <div className="click-to-buy-info-page__top">
                            <UserAgent tablet computer>
                                <Sticky onStateChange={onStickyChange} innerZ={900}>
                                    <div className={isSticky ? 'sticky-wrapper sticky-wrapper--sticky' : 'sticky-wrapper'}>
                                        <ImageHeaderMenu
                                            button={
                                                <BookingButton
                                                    objectId={currentObject.objectId}
                                                    inactive={!currentObject.isBookable && !bookable}
                                                    objectVipKey={viewModel.objectVipKey}
                                                    goToForm
                                                />
                                            }
                                        >
                                            <li>
                                                <A
                                                    href="#"
                                                    variant={LinkStyle.DARK_BG}
                                                    onClick={scrollToSection(getHowItWorksId())}
                                                    title={getFormattedMessage('jm.components.ClickToBuyInfoPage.menuHowItWorks')} 
                                                >
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.menuHowItWorks" />
                                                </A>
                                            </li>

                                            <li>
                                                <A
                                                    href="#"
                                                    variant={LinkStyle.DARK_BG}
                                                    onClick={scrollToSection(getFaqId())}
                                                    title={getFormattedMessage('jm.components.ClickToBuyInfoPage.menuFaq')} 
                                                >
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.menuFaq" />
                                                </A>
                                            </li>
                                            <li>
                                                <A
                                                    href="#"
                                                    variant={LinkStyle.DARK_BG}
                                                    onClick={scrollToSection('buy-residence-terms-block')}
                                                    title={getFormattedMessage('jm.components.ClickToBuyInfoPage.menuTerms')} 
                                                >
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.menuTerms" />
                                                </A>
                                            </li>
                                            <li>
                                                <A
                                                    href="#"
                                                    variant={LinkStyle.DARK_BG}
                                                    onClick={scrollToSection('click-to-buy-info-contact-block')}
                                                    title={getFormattedMessage('jm.components.ClickToBuyInfoPage.menuContact')} 
                                                >
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.menuContact" />
                                                </A>
                                            </li>
                                        </ImageHeaderMenu>
                                    </div>
                                </Sticky>
                            </UserAgent>

                            <div className="click-to-buy-info-page__object">
                                {(currentObject.interiorImage && currentObject.interiorImage.url != null) &&
                                    <UserAgent tablet computer>
                                        <div className="click-to-buy-info-page__object__img" id="click-to-buy-info-overview">
                                            <AsyncImage
                                                image={currentObject.interiorImage}
                                                headerImage
                                                quality={ImageSizes.SIZE_2560}
                                                fullWidth={!isMobile}
                                                fullHeight={isMobile}
                                            />
                                        </div>
                                    </UserAgent>
                                }

                                {/*
                                <SiteSpecificContent showOnFinland>
                                    <C2BObjectInfoCard currentObject={currentObject} objectVipKey={viewModel.objectVipKey} termsInfoText={viewModel.termsInfoText} onStartPage />
                                </SiteSpecificContent>
                                */}

                                <C2BObjectInfoCardNew currentObject={currentObject} objectVipKey={viewModel.objectVipKey} onStartPage noPaymentInfo={getCurrentSite() === SITE.NO} />

                            </div>

                            <SiteSpecificContent showOnFinland>
                                <MainGrid>
                                    <div className="click-to-buy-info-page__security">
                                        <div className="icon-wrapper">
                                            <Icon name="lock" size={24} />
                                        </div>
                                        <div className="click-to-buy-info-page__security__text">
                                            <Headline level={HeadlineLevel.H5} margin={Margin.S}>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeOne" />
                                            </Headline>
                                            <P>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeOneText" />
                                            </P>
                                        </div>
                                    </div>
                                    <div className="click-to-buy-info-page__security">
                                        <div className="icon-wrapper">
                                            <Icon name="return" />
                                        </div>
                                        <div className="click-to-buy-info-page__security__text">
                                            <Headline level={HeadlineLevel.H5} margin={Margin.S}>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeTwo" />
                                            </Headline>
                                            <P>
                                                <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeTwoText" />
                                            </P>
                                        </div>
                                    </div>
                                    <SiteSpecificContent notFinland>
                                        <div className="click-to-buy-info-page__security">
                                            <div className="icon-wrapper">
                                                <Icon name="block-safety-package" />
                                            </div>
                                            <div className="click-to-buy-info-page__security__text">
                                                <Headline level={HeadlineLevel.H5} margin={Margin.S}>
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeThree" />
                                                </Headline>
                                                <P>
                                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.safeThreeText" />
                                                </P>
                                            </div>
                                        </div>
                                    </SiteSpecificContent>
                                </MainGrid>
                            </SiteSpecificContent>
                        </div>

                        <ContentArea id="click-to-buy-info-page" blocks={viewModel.contentArea} />

                        <InspirationBlock
                            id="buy-residence-terms-block"
                            renderStyle=""
                            component=""
                            data={{
                                openInNewWindow: false,
                                title: getFormattedMessage('jm.components.ClickToBuyInfoPage.termsTitle'),
                                mainBody: getFormattedMessage('jm.components.ClickToBuyInfoPage.termsContent'),
                                url: currentObject.agreementIsBinding ? viewModel.buyResidenceBindingTermsPage : viewModel.buyResidenceTermsPage,
                                image: viewModel.termsBlockImage
                            }}
                        />

                        {currentObject.realEstateAgents && currentObject.realEstateAgents.length > 0 &&
                            <Container narrow className="click-to-buy-info-page__contact" id="click-to-buy-info-contact-block">
                                <Headline level={HeadlineLevel.H3} center>
                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.contactHeadline" />
                                </Headline>
                                <P center>
                                    <FormattedMessage id="jm.components.ClickToBuyInfoPage.contactText" />
                                </P>

                                <div className="click-to-buy-info-page__contact__box">
                                    {currentObject.realEstateAgents.map((agent, agentIndex) => (
                                        <ContactCard
                                            img={agent.imageUrl}
                                            name={agent.name}
                                            title={agent.title}
                                            company={agent.company}
                                            phone={agent.phone}
                                            mail={agent.email}
                                            key={`borker-${agentIndex}`}
                                        />
                                    ))}
                                </div>
                            </Container>
                        }

                        <UserAgent mobile tablet>
                            <div className="mobile-cta">
                                <Button 
                                    href={getBuyUrl()} 
                                    buttonState={!currentObject.isBookable && !bookable
                                        ? ButtonState.INACTIVE
                                        : ButtonState.DEFAULT
                                    } 
                                    buttonColor={ButtonColor.PURCHASE} 
                                    buttonSize={ButtonSize.WIDE} 
                                    buttonType={ButtonType.DEFAULT} 
                                >
                                    <FormattedMessage id='jm.components.ClickToBuyBanner.bookThis' />
                                </Button>
                            </div>
                        </UserAgent>
                    </div>
                </React.Fragment>
            }
        </div>
    )
};

